import settlementTransaction from './settlement-transaction.vue'

export default settlementTransaction
